import type * as React from "react";
import { cn } from "../cn";

// Design spec §8.2 (DTP `.profile`): a 36 px initials avatar, name 13 / 600, email 12 px. The
// account menu's header.
function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}

function ProfileCard({
  name,
  email,
  role,
  actions,
  className,
  ...props
}: Omit<React.ComponentProps<"div">, "role"> & {
  name: string;
  email?: string;
  role?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div
      data-slot="profile-card"
      className={cn("flex items-center gap-3 px-3 py-2.5", className)}
      {...props}
    >
      <span
        aria-hidden="true"
        className="inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-primary-soft text-sm font-semibold text-primary-text"
      >
        {initialsOf(name)}
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm font-semibold text-foreground">{name}</span>
        {email ? <span className="truncate text-xs text-muted-foreground">{email}</span> : null}
        {role ? <span className="truncate text-xs text-muted-foreground">{role}</span> : null}
      </span>
      {actions}
    </div>
  );
}

export { initialsOf, ProfileCard };
